<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M19.9331 2.50049H5.0671C3.6549 2.50049 2.5 3.54566 2.5 5.06722V19.9327C2.5 21.4543 3.6549 22.4995 5.0671 22.4995H19.9331C21.3449 22.4995 22.5 21.4543 22.5 19.9327V5.06722C22.5 3.54566 21.3449 2.50049 19.9331 2.50049ZM16.1676 5.62258C16.1676 5.1271 16.5724 4.72217 17.0677 4.72217H19.3282C19.8235 4.72217 20.2287 5.1271 20.2287 5.62258V7.77761C20.2287 8.27289 19.8235 8.67802 19.3282 8.67802H17.0677C16.5724 8.67802 16.1676 8.27289 16.1676 7.77761V5.62258ZM20.2399 10.9578H18.4796C18.6462 11.5016 18.7363 12.0776 18.7363 12.6734C18.7363 15.9999 15.9526 18.6964 12.5193 18.6964C9.08625 18.6964 6.30292 15.9999 6.30292 12.6734C6.30292 12.0771 6.39286 11.5014 6.55961 10.9578H4.72274V19.4057C4.72274 19.8428 5.08046 20.2008 5.51786 20.2008H19.4452C19.8826 20.2008 20.2403 19.8431 20.2403 19.4057V10.9578H20.2399ZM8.50161 12.4565C8.50161 10.307 10.3001 8.56473 12.5183 8.56473C14.7369 8.56473 16.5354 10.307 16.5354 12.4565C16.5354 14.606 14.7367 16.3483 12.5183 16.3483C10.3001 16.3483 8.50161 14.606 8.50161 12.4565Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgInstagram',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>